/**
 * FieldFeedbackBadge — small Megaphone indicator for fields/groups that
 * have unresolved (or any) feedback. Reads counts from FieldFeedbackContext
 * and delegates rendering to the presentational `FeedbackBadge`. Renders
 * nothing when the field has no feedback or no provider is mounted.
 */

import { FeedbackBadge } from './FeedbackBadge';
import { useFieldFeedback } from './FieldFeedbackContext';

interface FieldFeedbackBadgeProps {
  fieldId: string;
  /** Smaller variant for dense rows. Default: regular. */
  size?: 'regular' | 'small';
}

export function FieldFeedbackBadge({
  fieldId,
  size = 'regular',
}: FieldFeedbackBadgeProps) {
  const counts = useFieldFeedback(fieldId);
  if (!counts || counts.total === 0) return null;

  return (
    <FeedbackBadge
      unhandled={counts.unhandled}
      total={counts.total}
      size={size}
    />
  );
}
